export default __webpack_public_path__ + "static/sme_2-f94976265191e437eddf19b77ad0e1ef.jpg";